import React from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@groupby/ui-components';
import { StyledCustomizeViewSlot, StyledDropDownLabel, StyledDropDownLabelName, StyledLeadingControls, StyledQuickFilterButton, StyledQuickFilterItem, StyledSearchField, StyledSearchFieldWrapper, StyledSpacer, StyledTableFilterBar, } from './table-filter-bar.styles';
import { useLocalization } from '@/localization';
import { HeaderFilterMenu } from '../table-header/partials/header-filter-menu';
import { TableCustomizeView } from '../table-customize-view';
// Sentence case, value inline (design alignment spec §7/§9) — replaces the
// previous uppercase label + count badge. Applies wherever TableFilterBar
// renders (the Rules table included, not just the calendar).
const resolveQuickFilterValueSummary = (value, options, t) => {
    if (value.length === 0) {
        return t({ key: 'TABLE_QUICK_FILTER_ALL' });
    }
    if (value.length === 1) {
        const selectedOption = options.find((option) => option.value === value[0]);
        if (selectedOption) {
            return String(selectedOption.label);
        }
    }
    return t({ key: 'TABLE_QUICK_FILTER_SELECTED_COUNT', values: { count: value.length } });
};
export const TableFilterBar = ({ filter, columns, updateFilter, quickFilters = [], setOrder, showCustomizeView = true, leadingControls, }) => {
    var _a;
    const { formatMessage: t } = useLocalization();
    const [menuName, setMenuName] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (name, e) => {
        setMenuName(name);
        setAnchorEl(e.currentTarget);
        e.stopPropagation();
    };
    const handleClose = (e) => {
        setMenuName(null);
        setAnchorEl(null);
        e.stopPropagation();
    };
    const updateIncludesFilter = (newValue, filterConfig) => {
        if (newValue.length === 0) {
            const _filter = filter;
            delete _filter.includes[filterConfig.key];
            updateFilter(filter);
        }
        else {
            updateFilter(Object.assign(Object.assign({}, filter), { includes: Object.assign(Object.assign({}, ((filter === null || filter === void 0 ? void 0 : filter.includes) || {})), { [filterConfig.key]: filterConfig.set(newValue) }) }));
        }
    };
    const handleSearchChange = (newValue) => {
        updateFilter(Object.assign(Object.assign({}, filter), { search: newValue }));
    };
    return (<StyledTableFilterBar>
      {leadingControls && (<StyledLeadingControls data-testid="table-filter-bar-leading-controls">
          {leadingControls}
        </StyledLeadingControls>)}
      {quickFilters.map(({ label, filterConfig }) => {
            const value = filterConfig.get(filter);
            const options = filterConfig.options();
            const selectedSummary = resolveQuickFilterValueSummary(value, options, t);
            return (<StyledQuickFilterItem key={label}>
            <StyledQuickFilterButton endIcon={<Icon variant="chevronDown"/>} $open={menuName === label} onClick={(e) => handleClick(label, e)}>
              <StyledDropDownLabel>
                <StyledDropDownLabelName>{`${label}:`}</StyledDropDownLabelName>
                {selectedSummary}
              </StyledDropDownLabel>
            </StyledQuickFilterButton>
            <HeaderFilterMenu anchorEl={anchorEl} onClose={handleClose} open={menuName === label} searchable={filterConfig.searchable} menuItems={options} value={value} updateFilter={(newValue) => updateIncludesFilter(newValue, filterConfig)}/>
          </StyledQuickFilterItem>);
        })}

      <StyledSearchFieldWrapper>
        <StyledSearchField fullWidth placeholder={t({ key: 'SEARCH' })} variant="outlined" value={filter === null || filter === void 0 ? void 0 : filter.search} onChange={(e) => handleSearchChange(e.target.value)} InputProps={{
            startAdornment: (<InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>),
            endAdornment: ((_a = filter === null || filter === void 0 ? void 0 : filter.search) === null || _a === void 0 ? void 0 : _a.length) > 0 && (<InputAdornment position="end">
                <IconButton onClick={() => handleSearchChange('')}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>),
        }}/>
      </StyledSearchFieldWrapper>
      <StyledSpacer />
      {setOrder && (<StyledCustomizeViewSlot data-testid="table-filter-bar-customize-view" $visible={showCustomizeView}>
          <TableCustomizeView columns={columns} setOrder={setOrder}/>
        </StyledCustomizeViewSlot>)}
    </StyledTableFilterBar>);
};
